const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = "animate--zoom-in";
const SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (
        elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)
      ) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute("data-cascade"))
          elementTarget.setAttribute("style", `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(
  rootEl = document,
  isDesignModeEvent = false
) {
  const animationTriggerElements = Array.from(
    rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME)
  );
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add("scroll-trigger--design-mode");
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: "0px 0px -50px 0px",
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const animationTriggerElements = Array.from(
    document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME)
  );

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty(
      "--zoom-in-ratio",
      1 + scaleAmount * percentageSeen(element)
    );

    window.addEventListener(
      "scroll",
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty(
          "--zoom-in-ratio",
          1 + scaleAmount * percentageSeen(element)
        );
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener("DOMContentLoaded", () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", (event) =>
    initializeScrollAnimationTrigger(event.target, true)
  );
  document.addEventListener("shopify:section:reorder", () =>
    initializeScrollAnimationTrigger(document, true)
  );
}

/** mt-image-selector **/
Array.from(document.querySelectorAll(".mt-image-selector__wrapper")).forEach(
  (container) => {
    var selectors = container.querySelectorAll(".mt-image-selector__selector");
    var itemSelects = Array.from(
      container.querySelectorAll(".mt-image-selector__item")
    );

    selectors.forEach((selector) => {
      selector.addEventListener("click", (e) => {
        selectors.forEach((item) => {
          item.classList.remove("selected");
        });
        e.target.classList.add("selected");
        var val = parseInt(e.target.getAttribute("data-val"));
        itemSelects.forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if (val == curVal) {
            item.classList.remove("unshow");
          } else {
            item.classList.add("unshow");
          }
        });
      });
    });
  }
);
/** mt-image-selector **/

/** mt-text-selector **/
Array.from(document.querySelectorAll(".mt-text-selector__wrapper")).forEach(
  (container) => {
    var selectors = container.querySelectorAll(".mt-text-selector__selector");
    var itemSelects = Array.from(
      container.querySelectorAll(".mt-text-selector__item")
    );
    selectors.forEach((selector) => {
      selector.addEventListener("click", (e) => {
        selectors.forEach((item) => {
          item.classList.remove("selected");
        });
        e.target.classList.add("selected");
        var val = parseInt(e.target.getAttribute("data-val"));
        itemSelects.forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if (val == curVal) {
            item.classList.remove("hidden");
            item.classList.remove("unshow");
          } else {
            item.classList.add("hidden");
            item.classList.add("unshow");
          }
        });
      });
    });
  }
);
/** mt-text-selector **/

/** mt-image-text-icons **/
Array.from(document.querySelectorAll(".mt-image-text-icons__wrapper")).forEach(
  (container) => {
    var selectors = container.querySelectorAll(".mt-image-text-icons__dot");
    var itemSelects = Array.from(
      container.querySelectorAll(".mt-image-text-icons__image")
    );

    selectors.forEach((selector) => {
      selector.addEventListener("click", (e) => {
        selectors.forEach((item) => {
          item.classList.remove("selected");
        });
        e.target.classList.add("selected");
        var val = parseInt(e.target.getAttribute("data-val"));
        itemSelects.forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if (val == curVal) {
            item.classList.add("blur_show");
          } else {
            item.classList.remove("blur_show");
          }
        });
      });
    });
  }
);
Array.from(document.querySelectorAll(".mt-image-text-icons__wrapper")).forEach(
  (container) => {
    var selectors = container.querySelectorAll(
      ".mt-image-text-icons__icon-item"
    );
    selectors.forEach((selector) => {
      selector.addEventListener("click", (e) => {
        selectors.forEach((item) => {
          item
            .querySelector(".mt-image-text-icons__arrow")
            .classList.remove("selected");
        });
        selector
          .querySelector(".mt-image-text-icons__arrow")
          .classList.add("selected");
        var val = parseInt(
          selector
            .querySelector(".mt-image-text-icons__arrow")
            .getAttribute("data-val")
        );
        Array.from(
          container.querySelectorAll(".mt-image-text-icons__icon-detail")
        ).forEach((item) => {
          var curVal = parseInt(item.getAttribute("data-val"));
          if (val == curVal) {
            item.classList.toggle("scale0");
          } else {
            item.classList.add("scale0");
          }
        });
      });
    });
  }
);
/** mt-image-text-icons **/

/** mt-video-list **/
Array.from(document.querySelectorAll(".mt-video-list_container")).forEach(
  (container) => {
    let btns = container.querySelector(".slider-buttons");
    let isClicked = false;
    let maxWidth =
      container.querySelector(".mt-video-list-wrapper").getBoundingClientRect()
        .left +
      container.querySelector(".mt-video-list-wrapper").getBoundingClientRect()
        .width;
    btns
      .querySelector(".slider-button--prev")
      .addEventListener("click", (e) => {
        if (isClicked) return;
        isClicked = true;
        let val = parseInt(btns.getAttribute("data-val"));
        if (val > 1) {
          val = parseInt(val) - 1;
          selectContent(val);
        } else {
          isClicked = false;
        }
      });
    btns
      .querySelector(".slider-button--next")
      .addEventListener("click", (e) => {
        if (isClicked) return;
        isClicked = true;
        let val = parseInt(btns.getAttribute("data-val"));
        let maxVal = parseInt(btns.getAttribute("data-max-val"));
        let width =
          itemSelects[itemSelects.length - 1].getBoundingClientRect().width +
          itemSelects[itemSelects.length - 1].getBoundingClientRect().left;
        if (val < maxVal && width > maxWidth) {
          val = val + 1;
          console.log(
            "max-width:" +
              maxWidth +
              ", width:" +
              width +
              ", item_width:" +
              itemSelects[itemSelects.length - 1].getBoundingClientRect()
                .width +
              ", item_left:" +
              itemSelects[itemSelects.length - 1].getBoundingClientRect().left
          );
          selectContent(val);
        } else {
          isClicked = false;
        }
      });
    let itemSelects = Array.from(
      container.querySelectorAll(".mt-video-list-item")
    );
    let firstLeft = itemSelects[0].offsetLeft;
    let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
    function selectContent(val) {
      let moveX = 0;
      if (itemSelects != null && itemSelects.length > 1) {
        moveX = firstLeft - leftX * (val - 1);
      }
      itemSelects.forEach((itemItem) => {
        container.querySelector(".mt-video-list-wrapper").scrollLeft = -moveX;
        console.log("leftX:" + leftX + ",val:" + val);
      });
      btns.setAttribute("data-val", val);
      isClicked = false;
    }
  }
);
/** mt-video-list **/

/** mt-reviews-tabs **/
Array.from(document.querySelectorAll(".mt-reviews-tabs__container")).forEach(
  (container) => {
    let dots = container.querySelector(".mt-reviews-tabs__dots");
    let itemSelects = Array.from(
      container.querySelectorAll(".mt-reviews-tabs__item")
    );
    if (dots != null && itemSelects != null) {
      Array.from(dots.querySelectorAll(".dot")).forEach((dot) => {
        dot.addEventListener("click", (e) => {
          let val = parseInt(e.target.getAttribute("data-val"));
          selectContent(parseInt(val));
        });
      });
      let times = parseInt(
        container.querySelector(".mt_interval_times").innerText
      );
      let maxVal = parseInt(dots.getAttribute("max-val"));
      let curIndex = 1;
      // 自动轮播
      setInterval(function () {
        if (curIndex < maxVal) {
          curIndex++;
        } else {
          curIndex = 1;
        }
        selectContent(curIndex);
      }, times * 1000);
      let firstLeft = container.querySelector(".mt_interval_times").offsetLeft;
      let leftX = 0;
      if (itemSelects.length > 1) {
        leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
        if (window.innerWidth >= 750) {
          firstLeft =
            firstLeft + itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
          selectContent(2);
        }
      }
      if (window.innerWidth < 750) {
        selectContent(1);
      }
      function selectContent(val) {
        let moveX = 0;
        if (itemSelects != null && itemSelects.length > 1) {
          moveX = firstLeft - leftX * (val - 1);
        }
        container.querySelector(".mt-reviews-tabs__items").style.marginLeft =
          moveX + "px";
        Array.from(dots.querySelectorAll(".dot")).forEach((item) => {
          if (parseInt(item.getAttribute("data-val")) == val) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
        Array.from(
          container.querySelectorAll(".mt-reviews-tabs__item")
        ).forEach((item) => {
          if (parseInt(item.getAttribute("data-val")) == val) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
        curIndex = val;
      }
    }
  }
);
/** mt-reviews-tabs **/

/** mt-showcase-products **/
Array.from(
  document.querySelectorAll(".mt-showcase-products__container")
).forEach((container) => {
  let points = container.querySelectorAll(".mt-showcase-products__pointer");
  points.forEach((point) => {
    point.addEventListener("click", (e) => {
      points.forEach((item) => {
        item.classList.remove("selected");
      });
      point.classList.add("selected");
      container
        .querySelectorAll(".mt-showcase-products__rblog")
        .forEach((item) => {
          if (item.getAttribute("data-val") == point.getAttribute("data-val")) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
    });
  });
});
/** mt-showcase-products **/

/** mt-slideshow **/
Array.from(document.querySelectorAll(".mt-slideshow__container")).forEach(
  (container) => {
    let dots = container.querySelector(".mt-slideshow__dots");
    let itemSelects = Array.from(
      container.querySelectorAll(".mt-slideshow__item")
    );
    if (dots != null && itemSelects != null) {
      Array.from(dots.querySelectorAll(".dot")).forEach((dot) => {
        dot.addEventListener("click", (e) => {
          let val = parseInt(e.target.getAttribute("data-val"));
          selectContent(parseInt(val));
        });
      });
      let times = parseInt(
        container.querySelector(".mt_interval_times").innerText
      );
      let maxVal = parseInt(dots.getAttribute("max-val"));
      let curIndex = 1;
      // 自动轮播
      setInterval(function () {
        if (curIndex < maxVal) {
          curIndex++;
        } else {
          curIndex = 1;
        }
        selectContent(curIndex);
      }, times * 1000);
      let firstLeft = itemSelects[0].offsetLeft;
      let leftX = 0;
      if (itemSelects.length > 1) {
        leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
      }
      function selectContent(val) {
        let moveX = 0;
        if (itemSelects != null && itemSelects.length > 1) {
          moveX = firstLeft - leftX * (val - 1);
        }
        container.querySelector(".mt-slideshow__items").style.marginLeft =
          moveX + "px";
        Array.from(dots.querySelectorAll(".dot")).forEach((item) => {
          if (parseInt(item.getAttribute("data-val")) == val) {
            item.classList.add("selected");
          } else {
            item.classList.remove("selected");
          }
        });
        curIndex = val;
      }
    }
  }
);
/** mt-slideshow **/

/** mt-image-grid **/
Array.from(
  document.querySelectorAll(".mt-image-grid__container .mb_show")
).forEach((container) => {
  let itemSelects = Array.from(
    container.querySelectorAll(".mt-image-grid__item")
  );
  if (itemSelects != null) {
    let timesEle = container.querySelector(".mt_interval_times");
    let times = parseInt(timesEle.innerText);
    let maxVal = itemSelects.length;
    let curIndex = 2;
    // 自动轮播
    setInterval(function () {
      if (curIndex < maxVal) {
        curIndex++;
      } else {
        curIndex = 1;
      }
      selectContent(curIndex);
    }, times * 1000);
    let firstLeft = 10;
    let leftX = 0;
    if (itemSelects.length > 1) {
      leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;
    }
    function selectContent(val) {
      let moveX = 0;
      if (itemSelects != null && itemSelects.length > 1) {
        moveX = firstLeft - leftX * (val - 1);
      }
      container.querySelector(".mt-image-grid__list").scrollLeft = -moveX;
      curIndex = val;
    }

    /** let xDown = null;
    let xDiff = null;
    container.addEventListener('mouseup', (e) => {
        xUp = e.originalEvent.changedTouches[0].pageX;
        xDiff = xDown - xUp;
        if (Math.abs(xDiff) > 0) {
            if (xDiff > 0) {
              if(curIndex < maxVal){
                curIndex++;
              }else{
                curIndex = 1;
              }
            } else {
              if(curIndex > 1){
                curIndex--;
              }else{
                curIndex = 1;
              }
            }
            selectContent(curIndex);
        }
        
        xDown = null;
    });
    container.addEventListener('mousedown', (e) => {
        xDown = e.originalEvent.changedTouches[0].pageX;
        xDiff = 0;
    }); **/
  }
});
/** mt-image-grid **/

/** header-mega-menu **/
document.querySelectorAll('[id^="Mt-HeaderMenu-"]').forEach((menu) => {
  const summary = menu.querySelector(".header__menu-item");
  const content = menu.querySelector(".header__linklist-item");
  let timer = null;
  summary.addEventListener("mouseenter", (event) => {
    clearTimeout(timer);
    event.currentTarget.parentElement.classList.add("selected");
  });
  summary.addEventListener("mouseleave", (event) => {
    const target = event.currentTarget;
    timer = setTimeout(function () {
      target.parentElement.classList.remove("selected");
    }, 100);
  });
  content.addEventListener("mouseenter", (event) => {
    clearTimeout(timer);
  });
  content.addEventListener("mouseleave", (event) => {
    const target = event.currentTarget;
    timer = setTimeout(function () {
      target.parentElement.classList.remove("selected");
    }, 100);
  });
  //composite-mega-menu
  var hfItems = Array.from(menu.querySelectorAll(".hf_item_li"));
  hfItems.forEach(function (item) {
    item.addEventListener("mousemove", function (e) {
      var blockId = "#" + e.target.getAttribute("data-block-id");
      var cls = "." + e.target.getAttribute("data-child");

      Array.from(
        menu.querySelectorAll(blockId + " .hs_item__container")
      ).forEach(function (childItem) {
        childItem.classList.add("un-show");
      });
      Array.from(
        menu.querySelectorAll(blockId + " .hp_item__container")
      ).forEach(function (childItem) {
        childItem.classList.add("un-show");
      });
      Array.from(menu.querySelectorAll(cls)).forEach(function (childItem) {
        childItem.classList.remove("un-show");
      });
    });
  });
  var hsItems = Array.from(menu.querySelectorAll(".ht_item_li"));
  var completed = true;
  hsItems.forEach(function (item) {
    item.addEventListener("mouseenter", function (e) {
      if (completed == true) {
        completed = false;
        var blockId = "#" + e.target.getAttribute("data-block-id");
        var cls = "." + e.target.getAttribute("data-child");
        Array.from(
          menu.querySelectorAll(blockId + " .hp_item__container")
        ).forEach(function (childItem) {
          childItem.classList.add("un-show");
        });
        Array.from(menu.querySelectorAll(cls)).forEach(function (childItem) {
          childItem.classList.remove("un-show");
        });
        completed = true;
      }
    });
  });
});

/** header-mega-menu **/

/** product-media  **/
Array.from(document.querySelectorAll(".product-media-modal__content")).forEach(
  (container) => {
    let btns = container.querySelector(".slider-buttons");
    let isClicked = false;
    btns
      .querySelector(".slider-button--prev")
      .addEventListener("click", (e) => {
        e.stopPropagation();
        if (isClicked) return;
        isClicked = true;
        let val = parseInt(btns.getAttribute("data-val"));
        if (val > 1) {
          val = parseInt(val) - 1;
          selectContent(val);
        } else {
          isClicked = false;
        }
      });
    btns
      .querySelector(".slider-button--next")
      .addEventListener("click", (e) => {
        e.stopPropagation();
        if (isClicked) return;
        isClicked = true;
        let val = parseInt(btns.getAttribute("data-val"));
        let maxVal = parseInt(btns.getAttribute("data-max-val"));
        if (val < maxVal) {
          val = parseInt(val) + 1;
          selectContent(val);
        } else {
          isClicked = false;
        }
      });
    let itemSelects = Array.from(
      container.querySelectorAll(".product-media-modal__imgs img")
    );

    function selectContent(val) {
      itemSelects.forEach((itemItem) => {
        if (itemItem.getAttribute("data-index") == val) {
          itemItem.classList.add("selected");
        } else {
          itemItem.classList.remove("selected");
        }
      });
      btns.setAttribute("data-val", val);
      isClicked = false;
    }
  }
);
/** product-media **/

/** main-product **/
if (document.querySelector(".dimentions_btn") != null) {
  document.querySelector(".dimentions_btn").addEventListener("click", (e) => {
    e.target.classList.add("selected");
    document.querySelector(".display_btn").classList.remove("selected");
    let index = 0;
    document.querySelectorAll(".main_item").forEach((itemItem) => {
      if (!itemItem.hasAttribute("variant") && index == 0) {
        itemItem.classList.add("is-active");
        index++;
      } else {
        itemItem.classList.remove("is-active");
      }
    });
  });
}
if (document.querySelector(".display_btn") != null) {
  document.querySelector(".display_btn").addEventListener("click", (e) => {
    e.target.classList.add("selected");
    document.querySelector(".dimentions_btn").classList.remove("selected");
    let index = 0;
    document.querySelectorAll(".main_item").forEach((itemItem) => {
      if (
        !itemItem.hasAttribute("variant") &&
        itemItem.classList.contains("checked") &&
        index == 0
      ) {
        itemItem.classList.add("is-active");
        index++;
      } else {
        itemItem.classList.remove("is-active");
      }
    });
  });
}
if (document.querySelector(".products-left_item") != null) {
  Array.from(document.querySelectorAll(".products-left_item")).forEach(
    (leftItem) => {
      leftItem.addEventListener("click", (e) => {
        let index = 0;
        let i = -2;
        Array.from(document.querySelectorAll(".products-left_item")).forEach(
          (item) => {
            if (leftItem != item) {
              item.classList.remove("selected");
            } else {
              item.classList.add("selected");
              index = i;
            }
            i++;
          }
        );
        if (index > 0) {
          document.querySelector(".products-left_items").scrollTop =
            (document.querySelector(".products-left_item").offsetHeight + 10) *
            index;
        }

        let mediaId = leftItem.getAttribute("data-medial-id");
        Array.from(document.querySelectorAll(".main_item")).forEach((item) => {
          if (mediaId == item.getAttribute("data-medial-id")) {
            document.querySelector(
              ".product__media-list.pc_show .product__main_items"
            ).scrollLeft =
              (document
                .querySelector("slider-component")
                .getBoundingClientRect().width +
                100) *
              (item
                .querySelector(".product-media-container")
                .getAttribute("data-position") -
                1);
          }
        });
        let btn_val = 0;
        Array.from(
          document.querySelectorAll(".product-media-modal__imgs img")
        ).forEach((itemItem) => {
          if (itemItem.getAttribute("data-media-id") == mediaId) {
            itemItem.classList.add("selected");
            btn_val = itemItem.getAttribute("data-index");
          } else {
            itemItem.classList.remove("selected");
          }
        });
        document
          .querySelector(".product-media-modal__content .slider-buttons")
          .setAttribute("data-val", btn_val);
      });
    }
  );
}
if (document.querySelector(".tying-products__wrapper") != null) {
  Array.from(document.querySelectorAll(".tying-products__wrapper")).forEach((container) => {
    container.querySelector(".tying-products__header").addEventListener("click", (e) => {
      container.classList.toggle("selected");
    });
    
    let items = Array.from(container.querySelectorAll(".tying-product"));
    items.forEach((item) => {
      item.addEventListener("click", (e) => {     
        items.forEach((curItem) => {
          if(curItem == item){
            if(curItem.querySelector(".tying-product__check").checked){
              curItem.querySelector(".tying-product__check").checked = false;
            }else{
              curItem.querySelector(".tying-product__check").checked = true;
            }
            
          }
        });
      });
    });
  });
}
/** main-product **/

/** header-tips **/
if (document.querySelector(".predictive-search-tip") != null) {
  Array.from(document.querySelectorAll(".predictive-search-tip")).forEach(
    (tip) => {
      tip.addEventListener("click", (e) => {
        document.querySelector("#Search-In-Modal").value = tip.textContent;
        document
          .querySelector(".search-modal__form .search-modal__form")
          .submit();
      });
    }
  );
}

if (document.querySelector(".menu-drawer__navigation-container") != null) {
  Array.from(
    document.querySelectorAll(
      ".menu-drawer__navigation-container .menu-drawer__menu-down"
    )
  ).forEach((item) => {
    item.addEventListener("click", (e) => {
      const count = item.nextElementSibling.querySelectorAll("li").length;
      if (count > 0 && !item.classList.contains("open")) {
        const height =
          item.nextElementSibling.querySelector("li").offsetHeight * count + 20;

        item.classList.add("open");
        item.nextElementSibling.style.height = height + "px";
        item.nextElementSibling.style.opacity = 1;
        item.nextElementSibling.style.visibility = "visible";
      } else {
        item.classList.remove("open");
        item.nextElementSibling.style.height = "0px";
        item.nextElementSibling.style.opacity = 0;
        item.nextElementSibling.style.visibility = "hidden";
      }
    });
  });
}

if (
  document.querySelector(
    ".mt-image-on-off__container .mt-image-on-off__items"
  ) != null
) {
  Array.from(
    document.querySelectorAll(
      ".mt-image-on-off__container .mt-image-on-off__items"
    )
  ).forEach((container) => {
    let imgs = container.querySelectorAll(".mt-image-on-off__image");
    let items = Array.from(
      container.querySelectorAll(
        ".mt-image-on-off__switchs .mt-image-on-off__switch"
      )
    );
    items.forEach((item) => {
      item.addEventListener("click", (e) => {
        if (item.classList.contains("selected")) {
          item.classList.remove("selected");
          item.querySelector(".mt-image-on-off__oft").textContent = "off";
        } else {
          item.classList.add("selected");
          item.querySelector(".mt-image-on-off__oft").textContent = "on";
        }
        const v1 = container.querySelector(
          ".mt-image-on-off__switch[data-index='1']"
        );
        const v2 = container.querySelector(
          ".mt-image-on-off__switch[data-index='2']"
        );
        const v3 = container.querySelector(
          ".mt-image-on-off__switch[data-index='3']"
        );
        let st = "";
        if (v1 == null || !v1.classList.contains("selected")) {
          st = st + "0";
        } else {
          st = st + "1";
        }
        if (v2 == null || !v2.classList.contains("selected")) {
          st = st + "0";
        } else {
          st = st + "1";
        }
        if (v3 == null || !v3.classList.contains("selected")) {
          st = st + "0";
        } else {
          st = st + "1";
        }
        imgs.forEach((img) => {
          if (img.getAttribute("data-index") == st) {
            img.classList.add("selected");
          } else {
            img.classList.remove("selected");
          }
        });
      });
      if (
        item.getAttribute("data-index") == 1 &&
        container.querySelector(".point_1_switch") != null
      ) {
        item.click();
      }
      if (
        item.getAttribute("data-index") == 2 &&
        container.querySelector(".point_2_switch") != null
      ) {
        item.click();
      }
      if (
        item.getAttribute("data-index") == 3 &&
        container.querySelector(".point_3_switch") != null
      ) {
        item.click();
      }
    });
  });
}

if (document.querySelector(".collection .card-wrapper") != null) {
  Array.from(document.querySelectorAll(".collection .card-wrapper")).forEach(
    (container) => {
      let items = container.querySelectorAll(".card__variant-img");
      let cardImgs = container.querySelectorAll(".card__media .motion-reduce");
      items.forEach((item) => {
        item.addEventListener("click", (e) => {
          const index = item.getAttribute("data-id");
          cardImgs.forEach((cardImg) => {
            if (cardImg.getAttribute("data-id") == index) {
              cardImg.classList.add("selected");
            } else {
              cardImg.classList.remove("selected");
            }
          });
          items.forEach((img) => {
            if (img == item) {
              img.classList.add("selected");
            } else {
              img.classList.remove("selected");
            }
          });
        });
      });
      const btn = container.querySelector(".card__variant-btn");
      if (btn != null) {
        btn.addEventListener("click", (e) => {
          items.forEach((img) => {
            img.classList.remove("hidden");
          });
          btn.style.display = "none";
        });
      }
    }
  );
}

if (document.querySelector(".footer-block__details-content") != null) {
  Array.from(
    document.querySelectorAll(".footer-block__details-content")
  ).forEach((container) => {
    Array.from(container.querySelectorAll(".footer-item-title")).forEach(
      (item) => {
        item.addEventListener("click", (e) => {
          const count = container.querySelectorAll(
            ".footer-item-links li"
          ).length;
          if (count > 0 && !item.classList.contains("open")) {
            const height = item.offsetHeight * count + 20;
            item.classList.add("open");
            item.nextElementSibling.style.height = height + "px";
            item.nextElementSibling.style.opacity = 1;
            item.nextElementSibling.style.visibility = "visible";
          } else {
            item.classList.remove("open");
            item.nextElementSibling.style.height = "0px";
            item.nextElementSibling.style.opacity = 0;
            item.nextElementSibling.style.visibility = "hidden";
          }
        });
      }
    );
  });
}

if (document.querySelector(".icon-with-text-slider") != null) {
  Array.from(document.querySelectorAll(".icon-with-text-slider")).forEach(
    (container) => {
      let items = Array.from(
        container.querySelectorAll(".icon-with-text-slider__item")
      );
      items.forEach((item) => {
        item.addEventListener("click", (e) => {
          items.forEach((curItem) => {
            if (curItem == item) {
              curItem.classList.add("selected");
            } else {
              curItem.classList.remove("selected");
            }
          });
          document
            .querySelector(
              ".popup-wins[data-type='icon-with-text-slider'][data-index='" +
                item.getAttribute("data-index") +
                "']"
            )
            .classList.remove("unshow");
        });
      });
    }
  );
}
function sleep(seconds) {
  return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
}
if (document.querySelector(".product-pop-image-width-text-container") != null) {
  Array.from(
    document.querySelectorAll(".product-pop-image-width-text-container")
  ).forEach((container) => {
    container
      .querySelector(".product-pop-image-width-text-open")
      .addEventListener("click", function (e) {
        document
          .querySelector(".popup-wins[data-type='pop-image-with-text']")
          .classList.remove("unshow");
      });
  });
}
if (document.querySelectorAll(".popup-close") != null) {
  document.querySelectorAll(".popup-close").forEach((item) => {
    item.addEventListener("click", function (e) {
      item.closest(".popup-wins").classList.add("unshow");
    });
  });
}
if (document.querySelector(".warranty_product") != null) {
    Array.from(document.querySelectorAll(".warranty_product")).forEach((container) => {
      container.querySelector(".learn_more").addEventListener("click", function(e){
        document.querySelector(".popup-wins[data-type='warranty_product']").classList.remove("unshow");
      });
    }); 
}
if (document.querySelector(".warranty_product .card-wrapper") != null) {
  Array.from(
    document.querySelectorAll(".warranty_product .card-wrapper")
  ).forEach((card) => {
    let item = card.querySelector(".p_check_box input"); 
    item.addEventListener("click", function (e) {      
      const id = card.querySelector(".product-variant-id[name='id']").value;
      const cartItems = document.querySelector("cart-items") || document.querySelector("cart-drawer-items");
      let cartItem = cartItems.querySelector(".cart-items .cart-item[data-variant-id='" + id + "']");
      if (item.checked) {
        if (cartItem != null) {
          cartItems.updateQuantity(
            cartItem.getAttribute("data-index"),
            parseInt(cartItem.getAttribute("data-count")) + 1 + ""
          );          
        } else {
          let formData = {
            items: [
              {
                id: id,
                quantity: 1,
              },
            ],
          };
          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => response.json())
            .then((data) => {    
                const count =  cartItems.querySelectorAll(".cart-items .cart-item").length;
                cartItems.updateQuantity(
                  count,
                  data.items[0].quantity + ""
                );   
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      } else {
        cartItems.updateQuantity(cartItem.getAttribute("data-index"), parseInt(cartItem.getAttribute("data-count")) - 1 + "");
      }
    });
  });
}
window.addEventListener("DOMContentLoaded", () => {
   const loox = document.querySelector("product-info .loox-rating");
   if(loox != null && loox.getAttribute("data-rating") !=  ""){
     document.querySelector(".review_product__inventory").classList.remove("unshow");
     document.querySelector(".price_product__inventory").classList.add("unshow");
   }
});

/**  mt-children-collections **/
if (document.querySelector(".mt-children-collections__container") != null) {
    Array.from(document.querySelectorAll(".mt-children-collections__container")).forEach((container) => {
      const progressBar = container.querySelector('.progress-bar');
      const progress = document.querySelector('.progress');
      const images = document.querySelectorAll('.mt-children-collections__item');
      const innerWidth = document.querySelector(".mt-children-collections__inner");
      
      const totalImages = images.length;
      progressBar.addEventListener('click', (e) => {
        const rect = progressBar.getBoundingClientRect();
        const clickPosition = e.clientX - rect.left;
        const progressWidth = clickPosition / rect.width;
        updateProgress(progressWidth);
      });
      progressBar.addEventListener('mousedown', (e) => {
        const rect = progressBar.getBoundingClientRect();
        const startPosition = e.clientX - rect.left;
        const onMouseMove = (e) => {
            const movePosition = e.clientX - rect.left;
            const progressWidth = movePosition / rect.width;
            updateProgress(progressWidth);
        };
        const onMouseUp = () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
      });

      function updateProgress(progressWidth) {
        progressWidth = Math.max(0, Math.min(1, progressWidth)); // 限制在 0 到 1 之间
        progress.style.width = `${progressWidth * 100}%`;

        const imageIndex = Math.floor(progressWidth * totalImages);
        images.forEach((img, index) => {
            img.classList.toggle('active', index === imageIndex);
        });
      }

      if(totalImages > 0){
        const process = Math.floor(document.querySelector(".mt-children-collections__inner").offsetWidth / document.querySelector(".mt-children-collections__item").offsetWidth);
        progress.style.width = `${progressWidth * 100}%`;
      }
      
  }); 
}
/**  mt-children-collections **/